import { Text } from "@shopify/polaris";
import { Handle, Position } from "reactflow";

function ButtonNode({ data }) {
  return (
    <div className="button-node">
      <Text variant="bodySm">{data.title}</Text>
      <Handle type="source" position={Position.Right} isConnectable={false} />
    </div>
  );
}

export default ButtonNode;
